import { useEffect } from 'react';
import { TwitterShareButton, TwitterIcon } from 'react-share';
import {
  SelectSessionButton,
} from './KeysAndSigningUI';
import {
  Header,
  ForDevelopment,
} from './MonacottoMiscUI';
import {
  TextLine3,
  TextArea2,
} from './UtilComponents';
import {
  useGlobalStateSelector,
  words,
  wallet,
} from './globalState';
import {
  handleClickDefaultPurchase,
  handleClickClearPurchase,
  handleClickSignPurchase,
  handleClickSendMona,
  handleClickEditCreatorInformation,
} from './itemDetail';
import {
  keepKeyPairsInMemory,
  handleClickNfc,
  getSecretsFromNativeApp,
  handleClickMpurse,
  getSecretsFromKeyCardRecords,
} from './keysAndSigning';
import { useNfcrwScan } from './nativeAppHooks';
import { NativeAppReadButton } from './NativeAppUI';
import {
  getMonacardInfoAfterAll,
} from './blockchain';
import {
  handleClickAddressHistory,
} from './monacottoMisc';
import {
  devLog,
  urlParamsStringify,
  handleClickScanQr,
} from './utils';
import iconMpurse from './mpurse.png';
import iconLock from './lock_FILL0_wght400_GRAD0_opsz48.svg';
import iconSwords from './swords_24dp_FILL0_wght400_GRAD0_opsz24.svg';
import iconDetail from './more_horiz_FILL0_wght400_GRAD0_opsz48.svg';
import iconCard from './book_FILL0_wght400_GRAD0_opsz48.svg';
import iconHome from './home_FILL0_wght400_GRAD0_opsz48.svg';
import iconList from './format_list_bulleted_FILL0_wght400_GRAD0_opsz48.svg';
import iconSign from './history_edu_FILL0_wght400_GRAD0_opsz48.svg';
import iconEdit from './edit_FILL0_wght400_GRAD0_opsz48.svg';
import imageNotAMonacard from './notAMonacard.png';
import logoMonacotto from './logoMonacotto.png';
import iconCotto from './cotto.png';
import iconCopy from './content_copy_FILL0_wght400_GRAD0_opsz48.svg';
import iconKeyCard from './playing_cards_FILL0_wght400_GRAD0_opsz24.svg';
import iconQr from './qr_code_2_FILL0_wght400_GRAD0_opsz24.svg';

// ITEM DETAIL
function ItemDetail() {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const navigate = useGlobalStateSelector( ({ navigate }) => navigate );
  const cookies = useGlobalStateSelector( ({ cookies }) => cookies );
  const setCookie = useGlobalStateSelector( ({ setCookie }) => setCookie );
  const item = state.itemDetail.item;
  // const exhibitor = state.itemDetail.exhibitor;
  const exhibitorName = state.usersGeneralIndex[item.addressMain] !== undefined ? state.usersGeneralIndex[item.addressMain].userName : '';
  const assetCommon = item.asset_longname === null ? item.asset : item.asset_longname;
  const monadomInfo = state.registeredCard[item.asset];

  let {
    // eslint-disable-next-line no-unused-vars
    cardName: cardName2,
    // eslint-disable-next-line no-unused-vars
    cardOwnerName: cardOwnerName2,
    // eslint-disable-next-line no-unused-vars
    cardDescription: cardDescription2,
    // eslint-disable-next-line no-unused-vars
    cid: cid2,
    cardImageUrl: cardImageUrl2,
    cardImageUrlSP: cardImageUrlSP2,
    isAMonacard: isAMonacard2,
  } = getMonacardInfoAfterAll(state, item, 'large');

  useEffect( () => {
    if (item.addressMain === undefined || item.exhibitNo === undefined) {
      devLog('itemDetail useEffect');
      navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/newcard' : '/newcard');
    }
  });

  useEffect( () => {
    dispatch({ type: 'setState', key: 'purchase',
      value: {
        purchaseNo: null,
        addressMain: state.purchase.addressMain,
        addressPayFrom: state.purchase.addressPayFrom,
        addressSendCardTo: state.purchase.addressSendCardTo,
        addressMainExhibitor: '',
        exhibitNo: '',
        amountToBuy: state.purchase.amountToBuy,
        signatureByAddressMain: '',
        signatureByAddressPayFrom: '',
        addressPayRoyaltyTo: null,
        disabled: false,
        status: 'waitingForSignature',
      }
    });
  }, []);

  let purchaseNo;

  if (state.purchase.purchaseNo !== undefined && state.purchase.purchaseNo !== null && state.purchase.purchaseNo !== '') {
    purchaseNo = state.purchase.purchaseNo;
  }
  else {
    purchaseNo = '-';
  }

  let supply;

  if (state.assetInfo[item.asset] !== undefined) {
    supply = state.assetInfo[item.asset].supply;
  }
  else {
    supply = null;
  }

  let lockedImage;

  if (state.assetInfo[item.asset] !== undefined && state.assetInfo[item.asset].locked) {
    lockedImage = <img className='size1p7x1p7' src={iconLock} alt='locked' />;
  }
  else {
    lockedImage = null;
  }

  let vendable;

  if (state.assetInfo[item.asset] !== undefined) {
    if (state.assetInfo[item.asset].vendable) {
      vendable =
        <div className='borderMonacotto padding0p3 marginTopBottom0p5'>
          {words.vendable[state.language]}
        </div>;
    }
    else {
      vendable =
        <div className='borderMonacotto padding0p3 marginTopBottom0p5'>
          {words.notVendable[state.language]}
        </div>;
    }
  }
  else {
    vendable = null;
  }

  let listed;

  if (state.assetInfo[item.asset] !== undefined) {
    if (state.assetInfo[item.asset].listed) {
      listed =
        <div className='borderMonacotto padding0p3 marginTopBottom0p5 marginLeft0p5'>
          {words.listed[state.language]}
        </div>;
    }
    else {
      listed =
        <div className='borderMonacotto padding0p3 marginTopBottom0p5 marginLeft0p5'>
          {words.notListed[state.language]}
        </div>;
    }
  }
  else {
    listed = null;
  }

  /*
  let reassignable;

  if (state.assetInfo[item.asset] !== undefined && state.assetInfo[item.asset].reassignable) {
    reassignable =
      <div className='borderMonacotto'>
        reassignable
      </div>;
  }
  else {
    reassignable = null;
  }
  */

  // モナダム登録有無

  let monadomCard;

  if (state.registeredCard[item.asset] !== undefined) {
    monadomCard =
    <div className='borderMonacotto padding0p3 marginTopBottom0p5 marginLeft0p5'>
      { 'MONADOM' }
    </div>;
  }

  let cardName;
  let cardDescription;

  if (state.assetInfo[item.asset] !== undefined) {
    try {
      const description = JSON.parse(state.assetInfo[item.asset].description);
      cardName = description.monacard.name;
      cardDescription = description.monacard.desc;
    }
    catch (err) {
      if (state.monacard[item.asset] !== undefined) {
        cardName = state.monacard[item.asset].card_name;
        cardDescription = state.monacard[item.asset].add_description;
      }
      else {
        cardName = null;
        cardDescription = null;
      }
    }
  }
  else {
    cardName = null;
    cardDescription = null;
  }

  let soldOut;

  if (item.status === 'soldOut') {
    soldOut = <div className='soldOut'>
      SOLD OUT
    </div>;
  }
  else {
    soldOut = null;
  }

  // 保有数
  let balance;
  let balanceNum = 0;

  for (const address of Object.keys(state.session)) {
    if (state.session[address].expirationOfSession >= Date.now()) {
      balanceNum += state.balance.monaparty[address]?.[item.asset]?.quantity || 0;
    }
  }

  if (Object.keys(state.session).length > 0) {
    balance = <div className='flexRow alignItemsFlexEnd marginSide1'>
      <div className=''>
        {words.numberOfHoldings[state.language]}
      </div>
      <div className='font1p5 marginSide0p5'>
        { balanceNum }
      </div>
    </div>
  }
  else {
    balance = null;
  }

  const urlParams = [`mainaddress=${item.addressMain}`, `exhibitno=${item.exhibitNo}`, `asset=${assetCommon}`];
  if (state.language !== 'japanese') {
    urlParams.push(`language=${state.language}`);
  }
  const urlParamsStr = urlParamsStringify(urlParams);
  const url = `https://${process.env.REACT_APP_MONACOTTO_EXTENSION_URL}redirect${urlParamsStr}`;
  const title = `もなこっと ${exhibitorName}のマイホームで ${assetCommon} 出品中です。`
  const hashtags = ['monacotto', 'もなこっと'];

  const confirmTheDetailsOfSendingMona = <button className='buttonMainColor heightMin3 paddingSide1' tabindex='0'
    onClick={ () => {
      const popup = {
        type: 'sendMonaConfirmation',
        body: {
          addressPayProceedsTo: item.addressPayProceedsTo,
          addressPayRoyaltyTo: state.purchase.addressPayRoyaltyTo,
          monacottoAddressMona: state.config.monacottoAddress.monacottoAddressMona,
          proceedsNetMona: item.proceedsNetMona * state.purchase.amountToBuy,
          royaltyMona: item.royaltyMona * state.purchase.amountToBuy,
          feeMona: item.feeMona * state.purchase.amountToBuy,
          transactionFeeUpperBound: state.config.clientParameters.transactionFeeUpperBound,
        },
      };

      dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: popup });
    }}
  >
    {words.confirmTheDetailsOfSendingMona[state.language]}
  </button>

  let confirmation;

  if (wallet === 'MonaPallet') {
    confirmation = confirmTheDetailsOfSendingMona;
  }
  else { // Mpurse
    confirmation = null;
  }

  // モナダムボタン

  let monadomInfoButton;

  if (monadomInfo !== undefined) {
    monadomInfoButton =
    <button className='button1' tabindex='0'
      onClick={ () => {
        const card = {
          ...item,
          cardImageUrl: cardImageUrl2,
          cardImageUrlSP: cardImageUrlSP2,
          isAMonacard: isAMonacard2,
        };

        const popup = {
          type: 'monadomInfo',
          body: {
            card,
          },
        };

        dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: popup });
      }}
    >
      <img className='size2x2' src={iconSwords} alt='' />
    </button>;
  }


  return (
    <div className=''>
      {/* PC */}
      <div className="visibleMiddleOrMore">
        <Header screen='itemDetail' />
        <div className='flexRow justifyContentCenter'>
          {/* image */}
          <div className='margin2'>
            {
              state.monacard[item.asset] !== undefined ?
              <img className='cardImageLarge' src={state.config.clientParameters.monacardUrl + state.monacard[item.asset].cid} alt='' />
              : null
            }
          </div>
          <div className='flexColumn' >
            <div className='margin2'>
              <div className='flexRow justifyContentFlexStart alignItemsCenter' >
                <div className='flexColumn' >
                  <div className='marginBottom0p5 font1p5'>
                    {assetCommon}
                  </div>
                  <div className='marginBottom0p5 '>
                    <span className='font1p5'>{item.priceMona}</span>
                    <span className=''>{' MONA'}</span>
                  </div>
                </div>
                <div className='marginSide1'>
                  { soldOut }
                </div>
              </div>
              <div className='flexRow alignItemsFlexEnd marginBottom0p5 '>
                <div className=''>
                  {words.amountToSell[state.language]}
                </div>
                <div className='font1p5 marginSide0p5'>
                  {`${item.amountFree} / ${supply}`}
                </div>
                { lockedImage }
                { balance }
              </div>
              <div className='flexRow alignItemsFlexEnd marginBottom0p5 '>
                { vendable }
                { listed }
                { monadomCard }
              </div>
              <div className='flexColumn marginTopBottom0p5'>
                <div>
                  {words.exhibitor[state.language]}
                </div>
                <div className='paddingLeft1'>
                  {state.usersGeneralIndex[item.addressMain] !== undefined ? <span>{state.usersGeneralIndex[item.addressMain].userName}<br/></span> : null}
                  {item.addressMain}
                </div>
              </div>
              <div className='flexColumn marginBottom0p5'>
                <div>
                  {words.owner[state.language]}
                </div>
                <div className='paddingLeft1'>
                  {state.usersGeneralIndex[item.addressOwner] !== undefined ? <span>{state.usersGeneralIndex[item.addressOwner].userName}<br/></span> : null}
                  {item.addressOwner}
                </div>
              </div>
            </div>
            <div className='flexColumn margin2'>
              <div className='widthMax25 font1p5 marginBottom0p5'>
                {/* state.monacard[item.asset] !== undefined ? state.monacard[item.asset].card_name : null */}
                { cardName }
              </div>
              <div className='widthMax25'>
                {/* state.monacard[item.asset] !== undefined ? state.monacard[item.asset].add_description : null */}
                { cardDescription }
              </div>
            </div>
            <div className='flexRow margin2'>
              {/* item detail more */}
              <button className='button1' tabindex='0'
                onClick={ () => {
                  const popup = { type: 'itemDetailMore', body: item };
                  dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: popup });
                }}
              >
                <img className='size2x2' src={iconDetail} alt='' />
              </button>
              {/* Monacard */}
              <button className='button1' tabindex='0'
                onClick={ () => window.open(`https://card.mona.jp/explorer/card_detail?asset=${item.asset}`) }
              >
                <img className='size2x2' src={iconCard} alt='' />
              </button>
              {/* monadomInfo */}
              { monadomInfoButton }
              {/* back home */}
              <button className='button1' tabindex='0'
                onClick={ () => {
                  dispatch({ type: 'setStateMultiLayers', keys: ['gallery', 'addressMain'], value: item.addressMain });
                  navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/home' : '/home'); 
                }}
              >
                <img className='size2x2' src={iconHome} alt='' />
              </button>
              {/* twitter */}
              <div className='margin0p5'>
                <TwitterShareButton
                  url={url}
                  title={title}
                  hashtags={hashtags}
                >
                  <TwitterIcon size={32} round />
                </TwitterShareButton>
              </div>
            </div>
            {/* purchase */}
            <div className='margin2'>
              <div className='flexRow justifyContentFlexStart alignItemsCenter marginTop1 '>
                <div className='flexRow justifyContentSpaceBetween alignItemsCenter marginTop1 widthMax'>
                  <div>
                    { 'No. ' + purchaseNo }
                  </div>
                  <div>
                    <button className='borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginSide0p2 ' tabindex='0'
                      onClick={ () => { handleClickDefaultPurchase(state, dispatch) } }
                    >
                      {words.default[state.language]}
                    </button>
                    <button className='borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginSide0p2 ' tabindex='0'
                      onClick={ () => { handleClickClearPurchase(state, dispatch) } }
                    >
                      {words.clear[state.language]}
                    </button>
                  </div>
                </div>
              </div>
              <div className='flexRow justifyContentFlexStart alignItemsCenter marginTop1 '>
                <TextLine3 fieldName='purchaseAddressMain' keys={['purchase', 'addressMain']} face={words.addressMain[state.language]} tooltip={true} disabled={state.purchase.disabled} />
                <SelectSessionButton loginEnabled={true} setConfigure={true} />
                <button className='button1' disabled={state.purchase.disabled} onClick={ () => handleClickMpurse(state, dispatch, ['purchase', 'addressMain']) }>
                  <img className='size2x2' src={iconMpurse} alt='' />
                </button>
                <button className='button1' disabled={state.purchase.disabled} onClick={ () => handleClickAddressHistory(state, dispatch, cookies, ['purchase', 'addressMain']) }>
                  <img className='size2x2' src={iconList} alt='' />
                </button>
              </div>
              <div className='flexRow justifyContentFlexStart alignItemsCenter marginTop1 '>
                <TextLine3 fieldName='addressPayFrom' keys={['purchase', 'addressPayFrom']} face={words.addressPayFrom[state.language]} tooltip={true} disabled={state.purchase.disabled} />
                <SelectSessionButton stateKeysToSetAddress={[['purchase', 'addressPayFrom']]} stateKeysToSetUserName={[]} />
                <button className='button1' disabled={state.purchase.disabled} onClick={ () => handleClickMpurse(state, dispatch, ['purchase', 'addressPayFrom']) }>
                  <img className='size2x2' src={iconMpurse} alt='' />
                </button>
                <button className='button1' disabled={state.purchase.disabled} onClick={ () => handleClickAddressHistory(state, dispatch, cookies, ['purchase', 'addressPayFrom']) }>
                  <img className='size2x2' src={iconList} alt='' />
                </button>
              </div>
              <div className='flexRow justifyContentFlexStart alignItemsCenter marginTop1 '>
                <TextLine3 fieldName='addressSendCardTo' keys={['purchase', 'addressSendCardTo']} face={words.addressSendCardTo[state.language]} tooltip={true} disabled={state.purchase.disabled} />
                <SelectSessionButton stateKeysToSetAddress={[['purchase', 'addressSendCardTo']]} stateKeysToSetUserName={[]} />
                <button className='button1' disabled={state.purchase.disabled} onClick={ () => handleClickMpurse(state, dispatch, ['purchase', 'addressSendCardTo']) }>
                  <img className='size2x2' src={iconMpurse} alt='' />
                </button>
                <button className='button1' disabled={state.purchase.disabled} onClick={ () => handleClickAddressHistory(state, dispatch, cookies, ['purchase', 'addressSendCardTo']) }>
                  <img className='size2x2' src={iconList} alt='' />
                </button>
              </div>
              <TextLine3 fieldName='amountToBuy' keys={['purchase', 'amountToBuy']} face={words.amountToBuy[state.language]} type='setStateMultiLayersNum' disabled={state.purchase.disabled} />
              {
                (state.purchase.signatureByAddressMain === undefined ||
                 state.purchase.signatureByAddressMain === null ||
                 state.purchase.signatureByAddressMain === '') ?
                  <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
                    onClick={ async () => { 
                      const result = await handleClickSignPurchase(state, dispatch, cookies, setCookie, 'addressMain');

                      if (result?.message === 'nfcRequired') {
                        const callback = (keyPairs) => {
                          handleClickSignPurchase(state, dispatch, cookies, setCookie, 'addressMain', null, keyPairs);
                          keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                        };

                        handleClickNfc(state, dispatch, callback);
                      }
                      else if (result?.message === 'nfcNativeRequired') {
                        const { keyPairs } = await getSecretsFromNativeApp({ dispatch, pass: state.config.clientParameters.specialMessage, language: state.language, network: state.networkMona });

                        handleClickSignPurchase(state, dispatch, cookies, setCookie, 'addressMain', null, keyPairs);
                        keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                      }
                      else if (result?.message === 'bcRequired') {
                        const callback = (keyPairs) => {
                          handleClickSignPurchase(state, dispatch, cookies, setCookie, 'addressMain', null, keyPairs);
                          keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                        };

                        handleClickScanQr(state, dispatch, callback);
                      }
                    }}
                  >
                    <div>
                      {words.signByMainAddress[state.language]}
                    </div>
                    <img className='size2x2' src={iconSign} alt='' />
                  </button>
                : null
              }
              {
                ( state.purchase.signatureByAddressMain !== undefined &&
                  state.purchase.signatureByAddressMain !== null &&
                  state.purchase.signatureByAddressMain !== '' &&
                 (state.purchase.signatureByAddressPayFrom === undefined ||
                  state.purchase.signatureByAddressPayFrom === null ||
                  state.purchase.signatureByAddressPayFrom === '')) ?
                  <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
                    onClick={ async () => {
                      const result = await handleClickSignPurchase(state, dispatch, cookies, setCookie, 'addressPayFrom');

                      if (result?.message === 'nfcRequired') {
                        const callback = (keyPairs) => {
                          handleClickSignPurchase(state, dispatch, cookies, setCookie, 'addressPayFrom', null, keyPairs);
                          keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                        };

                        handleClickNfc(state, dispatch, callback);
                      }
                      else if (result?.message === 'nfcNativeRequired') {
                        const { keyPairs } = await getSecretsFromNativeApp({ dispatch, pass: state.config.clientParameters.specialMessage, language: state.language, network: state.networkMona });

                        handleClickSignPurchase(state, dispatch, cookies, setCookie, 'addressPayFrom', null, keyPairs);
                        keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                      }
                      else if (result?.message === 'bcRequired') {
                        const callback = (keyPairs) => {
                          handleClickSignPurchase(state, dispatch, cookies, setCookie, 'addressPayFrom', null, keyPairs);
                          keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                        };

                        handleClickScanQr(state, dispatch, callback);
                      }
                    }}
                  >
                    <div>
                      {words.signByAddressYouPayFrom[state.language]}
                    </div>
                    <img className='size2x2' src={iconSign} alt='' />
                  </button>
                : null
              }
              {
                state.purchase.status === 'waitingForMona' ?
                  <div className='flexColumn alignItemsFlexStart'>
                    { confirmation }
                    <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
                      onClick={ async () => {
                        const result = await handleClickSendMona(state, dispatch);

                        if (result?.message === 'nfcRequired') {
                          const callback = (keyPairs) => {
                            handleClickSendMona(state, dispatch, null, keyPairs);
                            keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                          };

                          handleClickNfc(state, dispatch, callback);
                        }
                        else if (result?.message === 'nfcNativeRequired') {
                          const { keyPairs } = await getSecretsFromNativeApp({ dispatch, pass: state.config.clientParameters.specialMessage, language: state.language, network: state.networkMona });

                          handleClickSendMona(state, dispatch, null, keyPairs);
                          keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                        }
                        else if (result?.message === 'bcRequired') {
                          const callback = (keyPairs) => {
                            handleClickSendMona(state, dispatch, null, keyPairs);
                            keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                          };

                          handleClickScanQr(state, dispatch, callback);
                        }
                      }}
                    >
                      {words.sendMona[state.language]}
                    </button>
                  </div>
                : null
              }
                    {/* <button className='button2 borderRadius2 riseOut2' tabindex='0' */}
            </div>
          </div>
        </div>
        {/* development */}
        <div>
          { process.env.REACT_APP_ENVIRONMENT === 'dev' ? <ForDevelopment /> : null }
        </div>
      </div>
      {/* SP */}
      <div className="flexColumn alignItemsCenter visibleSmallOrLess ">
        <Header screen='itemDetail' />
        {/* image */}
        <div className='marginTopBottom1'>
          {
            state.monacard[item.asset] !== undefined ?
            <img className='cardImageFullWidth' src={state.config.clientParameters.monacardUrl + state.monacard[item.asset].cid} alt='' />
            : null
          }
        </div>
        <div className='flexColumn alignItemsCenter marginTopBottom1'>
          <div className='widthMax'>
            <div className='flexRow justifyContentFlexStart alignItemsCenter' >
              <div className='flexColumn' >
                <div className='marginBottom0p5 font1p5'>
                  {assetCommon}
                </div>
                <div className='marginBottom0p5 '>
                  <span className='font1p5'>{item.priceMona}</span>
                  <span className=''>{' MONA'}</span>
                </div>
              </div>
              <div className='marginSide1'>
                { soldOut }
              </div>
            </div>
            <div className='flexRow alignItemsFlexEnd marginBottom0p5 '>
              <div className=''>
                {words.amountToSell[state.language]}
              </div>
              <div className='font1p5 marginSide0p5'>
                {`${item.amountFree} / ${supply}`}
              </div>
              { lockedImage }
              { balance }
            </div>
            <div className='flexRow alignItemsFlexEnd marginBottom0p5 '>
              { vendable }
              { listed }
              { monadomCard }
            </div>
            {/* exhibitor */}
            <div className='flexColumn marginTopBottom0p5'>
              <div>
                {words.exhibitor[state.language]}
              </div>
              <div className='paddingLeft1'>
                {state.usersGeneralIndex[item.addressMain] !== undefined ? <span>{state.usersGeneralIndex[item.addressMain].userName}<br/></span> : null}
                <span className='breakAll' >{item.addressMain}</span>
              </div>
            </div>
            {/* owner */}
            <div className='flexColumn marginBottom0p5 '>
              <div>
                {words.owner[state.language]}
              </div>
              <div className='paddingLeft1'>
                {state.usersGeneralIndex[item.addressOwner] !== undefined ? <span>{state.usersGeneralIndex[item.addressOwner].userName}<br/></span> : null}
                <span className='breakAll' >{item.addressOwner}</span>
              </div>
            </div>
            <div className='flexColumn marginTopBottom1'>
              {/* card name */}
              <div className='widthMax25 font1p5 marginBottom0p5'>
                {/* state.monacard[item.asset] !== undefined ? state.monacard[item.asset].card_name : null */}
                { cardName }
              </div>
              {/* description */}
              <div className='widthMax25'>
                {/* state.monacard[item.asset] !== undefined ? state.monacard[item.asset].add_description : null */}
                { cardDescription }
              </div>
            </div>
            <div className='flexRow marginTopBottom1'>
              {/* item detail more */}
              <button className='button1' tabindex='0'
                onClick={ () => {
                  const popup = { type: 'itemDetailMore', body: item };
                  dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: popup });
                }}
              >
                <img className='size2x2' src={iconDetail} alt='' />
              </button>
              {/* Monacard */}
              <button className='button1' tabindex='0'
                onClick={ () => window.open(`https://card.mona.jp/explorer/card_detail?asset=${item.asset}`) }
              >
                <img className='size2x2' src={iconCard} alt='' />
              </button>
              {/* monadomInfo */}
              { monadomInfoButton }
              {/* back home */}
              <button className='button1' tabindex='0'
                onClick={ () => {
                  dispatch({ type: 'setStateMultiLayers', keys: ['gallery', 'addressMain'], value: item.addressMain });
                  navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/home' : '/home'); 
                }}
              >
                <img className='size2x2' src={iconHome} alt='' />
              </button>
              {/* twitter */}
              <div className='margin0p5'>
                <TwitterShareButton
                  url={url}
                  title={title}
                  hashtags={hashtags}
                >
                  <TwitterIcon size={32} round />
                </TwitterShareButton>
              </div>
            </div>
          </div>
          {/* purchase */}
          <div className='flexColumn alignItemsCenter marginTopBottom1'>
            <div className='flexRow justifyContentSpaceBetween alignItemsCenter marginTop1 widthMax'>
              <div>
                { 'No. ' + purchaseNo }
              </div>
              <div>
                <button className='borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginSide0p2 ' tabindex='0'
                  onClick={ () => { handleClickDefaultPurchase(state, dispatch) } }
                >
                  {words.default[state.language]}
                </button>
                <button className='borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginSide0p2 ' tabindex='0'
                  onClick={ () => { handleClickClearPurchase(state, dispatch) } }
                >
                  {words.clear[state.language]}
                </button>
              </div>
            </div>
            <div className='flexColumn alignItemsFlexStart' >
              <div className='flexColumn justifyContentFlexStart marginTop1 '>
                <TextLine3 fieldName='purchaseAddressMain' keys={['purchase', 'addressMain']} face={words.addressMain[state.language]} tooltip={true} disabled={state.purchase.disabled} />
                <div className='flexRow justifyContentFlexStart alignItemsCenter' >
                  <SelectSessionButton loginEnabled={true} setConfigure={true} />
                  <button className='button1' disabled={state.purchase.disabled} onClick={ () => handleClickMpurse(state, dispatch, ['purchase', 'addressMain']) }>
                    <img className='size2x2' src={iconMpurse} alt='' />
                  </button>
                  <button className='button1' disabled={state.purchase.disabled} onClick={ () => handleClickAddressHistory(state, dispatch, cookies, ['purchase', 'addressMain']) }>
                    <img className='size2x2' src={iconList} alt='' />
                  </button>
                </div>
              </div>
              <div className='flexColumn alignItemsFlexStart marginTop1 '>
                <TextLine3 fieldName='addressPayFrom' keys={['purchase', 'addressPayFrom']} face={words.addressPayFrom[state.language]} tooltip={true} disabled={state.purchase.disabled} />
                <div className='flexRow justifyContentFlexStart alignItemsCenter' >
                  <SelectSessionButton stateKeysToSetAddress={[['purchase', 'addressPayFrom']]} stateKeysToSetUserName={[]} />
                  <button className='button1' disabled={state.purchase.disabled} onClick={ () => handleClickMpurse(state, dispatch, ['purchase', 'addressPayFrom']) }>
                    <img className='size2x2' src={iconMpurse} alt='' />
                  </button>
                  <button className='button1' disabled={state.purchase.disabled} onClick={ () => handleClickAddressHistory(state, dispatch, cookies, ['purchase', 'addressPayFrom']) }>
                    <img className='size2x2' src={iconList} alt='' />
                  </button>
                </div>
              </div>
              <div className='flexColumn alignItemsFlexStart marginTop1 '>
                <TextLine3 fieldName='addressSendCardTo' keys={['purchase', 'addressSendCardTo']} face={words.addressSendCardTo[state.language]} tooltip={true} disabled={state.purchase.disabled} />
                <div className='flexRow justifyContentFlexStart alignItemsCenter' >
                  <SelectSessionButton stateKeysToSetAddress={[['purchase', 'addressSendCardTo']]} stateKeysToSetUserName={[]} />
                  <button className='button1' disabled={state.purchase.disabled} onClick={ () => handleClickMpurse(state, dispatch, ['purchase', 'addressSendCardTo']) }>
                    <img className='size2x2' src={iconMpurse} alt='' />
                  </button>
                  <button className='button1' disabled={state.purchase.disabled} onClick={ () => handleClickAddressHistory(state, dispatch, cookies, ['purchase', 'addressSendCardTo']) }>
                    <img className='size2x2' src={iconList} alt='' />
                  </button>
                </div>
              </div>
            </div>
            <TextLine3 fieldName='amountToBuy' keys={['purchase', 'amountToBuy']} face={words.amountToBuy[state.language]} type='setStateMultiLayersNum' disabled={state.purchase.disabled} />
            {
              (state.purchase.signatureByAddressMain === undefined ||
               state.purchase.signatureByAddressMain === null ||
               state.purchase.signatureByAddressMain === '') ?
                <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
                  onClick={ async () => {
                    const result = await handleClickSignPurchase(state, dispatch, cookies, setCookie, 'addressMain');

                    if (result?.message === 'nfcRequired') {
                      const callback = (keyPairs) => {
                        handleClickSignPurchase(state, dispatch, cookies, setCookie, 'addressMain', null, keyPairs);
                        keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                      };

                      handleClickNfc(state, dispatch, callback);
                    }
                    else if (result?.message === 'nfcNativeRequired') {
                      const { keyPairs } = await getSecretsFromNativeApp({ dispatch, pass: state.config.clientParameters.specialMessage, language: state.language, network: state.networkMona });

                      handleClickSignPurchase(state, dispatch, cookies, setCookie, 'addressMain', null, keyPairs);
                      keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                    }
                    else if (result?.message === 'bcRequired') {
                      const callback = (keyPairs) => {
                        handleClickSignPurchase(state, dispatch, cookies, setCookie, 'addressMain', null, keyPairs);
                        keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                      };

                      handleClickScanQr(state, dispatch, callback);
                    }
                  }}
                >
                  <div>
                    {words.signByMainAddress[state.language]}
                  </div>
                  <img className='size2x2' src={iconSign} alt='' />
                </button>
              : null
            }
            {
              ( state.purchase.signatureByAddressMain !== undefined &&
                state.purchase.signatureByAddressMain !== null &&
                state.purchase.signatureByAddressMain !== '' &&
               (state.purchase.signatureByAddressPayFrom === undefined ||
                state.purchase.signatureByAddressPayFrom === null ||
                state.purchase.signatureByAddressPayFrom === '')) ?
                <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
                  onClick={ async () => {
                    const result = await handleClickSignPurchase(state, dispatch, cookies, setCookie, 'addressPayFrom');

                    if (result?.message === 'nfcRequired') {
                      const callback = (keyPairs) => {
                        handleClickSignPurchase(state, dispatch, cookies, setCookie, 'addressPayFrom', null, keyPairs);
                        keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                      };

                      handleClickNfc(state, dispatch, callback);
                    }
                    else if (result?.message === 'nfcNativeRequired') {
                      const { keyPairs } = await getSecretsFromNativeApp({ dispatch, pass: state.config.clientParameters.specialMessage, language: state.language, network: state.networkMona });

                      handleClickSignPurchase(state, dispatch, cookies, setCookie, 'addressPayFrom', null, keyPairs);
                      keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                    }
                    else if (result?.message === 'bcRequired') {
                      const callback = (keyPairs) => {
                        handleClickSignPurchase(state, dispatch, cookies, setCookie, 'addressPayFrom', null, keyPairs);
                        keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                      };

                      handleClickScanQr(state, dispatch, callback);
                    }
                  }}
                >
                  <div>
                    {words.signByAddressYouPayFrom[state.language]}
                  </div>
                  <img className='size2x2' src={iconSign} alt='' />
                </button>
              : null
            }
            {
              state.purchase.status === 'waitingForMona' ?
                <div className='flexColumn alignItemsCenter'>
                  <button className='buttonMainColor heightMin3 paddingSide1' tabindex='0'
                    onClick={ () => {
                      const popup = {
                        type: 'sendMonaConfirmation',
                        body: {
                          addressPayProceedsTo: item.addressPayProceedsTo,
                          addressPayRoyaltyTo: state.purchase.addressPayRoyaltyTo,
                          monacottoAddressMona: state.config.monacottoAddress.monacottoAddressMona,
                          proceedsNetMona: item.proceedsNetMona * state.purchase.amountToBuy,
                          royaltyMona: item.royaltyMona * state.purchase.amountToBuy,
                          feeMona: item.feeMona * state.purchase.amountToBuy,
                          transactionFeeUpperBound: state.config.clientParameters.transactionFeeUpperBound,
                        },
                      };

                      dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: popup });
                    }}
                  >
                    {words.confirmTheDetailsOfSendingMona[state.language]}
                  </button>
                  <button className='button2 borderRadius2 riseOut2' tabindex='0'
                    onClick={ async () => {
                      const result = await handleClickSendMona(state, dispatch);

                      if (result?.message === 'nfcRequired') {
                        const callback = (keyPairs) => {
                          handleClickSendMona(state, dispatch, null, keyPairs);
                          keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                        };

                        handleClickNfc(state, dispatch, callback);
                      }
                      else if (result?.message === 'nfcNativeRequired') {
                        const { keyPairs } = await getSecretsFromNativeApp({ dispatch, pass: state.config.clientParameters.specialMessage, language: state.language, network: state.networkMona });

                        handleClickSendMona(state, dispatch, null, keyPairs);
                        keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                      }
                      else if (result?.message === 'bcRequired') {
                        const callback = (keyPairs) => {
                          handleClickSendMona(state, dispatch, null, keyPairs);
                          keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                        };

                        handleClickScanQr(state, dispatch, callback);
                      }
                    }}
                  >
                    {words.sendMona[state.language]}
                  </button>
                </div>
              : null
            }
          </div>
        </div>
      </div>
    </div>
  );
}

// ITEM DETAIL MORE
function ItemDetailMore(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const record = state.popup[props.popupLayer].body;

  let supply;

  if (state.assetInfo[record.asset] !== undefined) {
    supply = state.assetInfo[record.asset].supply;
  }
  else {
    supply = null;
  }

  let lockState;

  if (state.assetInfo[record.asset] !== undefined) {
    if (state.assetInfo[record.asset].locked) {
      lockState = 'locked';
    }
    else {
      lockState = 'unlocked';
    }
  }
  else {
    lockState = 'blank';
  }

  let vendable;

  if (state.assetInfo[record.asset] !== undefined) {
    if (state.assetInfo[record.asset].vendable) {
      vendable = 'ok';
    }
    else {
      vendable = 'ng';
    }
  }
  else {
    vendable = 'blank';
  }

  let listed;

  if (state.assetInfo[record.asset] !== undefined) {
    if (state.assetInfo[record.asset].listed) {
      listed = 'ok';
    }
    else {
      listed = 'ng';
    }
  }
  else {
    listed = 'blank';
  }

  return (
    <div className=''>
      {/* PC */}
      <div className="flexColumn visibleMiddleOrMore">
        <div className='flexColumn boxDetail'>
          <div>
            {words.addressMainExhibitor[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.addressMain}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.exhibitorName[state.language]}
          </div>
          <div className='paddingLeft1'>
            { state.usersGeneralIndex[record.addressMain] !== undefined ? state.usersGeneralIndex[record.addressMain].userName : null }
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.exhibitNo[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.exhibitNo}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.asset[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.asset}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.asset_longname[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.asset_longname}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.addressOwner[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.addressOwner}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.ownerName[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.ownerName}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.addressPayRoyaltyTo[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.addressPayRoyaltyTo}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.royaltyRecipientName[state.language]}
          </div>
          <div className='paddingLeft1'>
            { state.usersGeneralIndex[record.addressPayRoyaltyTo] !== undefined ? state.usersGeneralIndex[record.addressPayRoyaltyTo].userName : null }
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.unitPriceMona[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.priceMona + ' MONA'}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.exhibitorProceedsNetMona[state.language]}
          </div>
          <div className='paddingLeft1'>
            {(record.proceedsNetMona / 100000000) + ' MONA'}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.royaltyMona[state.language]}
          </div>
          <div className='paddingLeft1'>
            {(record.royaltyMona / 100000000) + ' MONA'}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.feeExhibitMona[state.language]}
          </div>
          <div className='paddingLeft1'>
            {(record.feeExhibitMona / 100000000) + ' MONA'}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.feePurchaseMona[state.language]}
          </div>
          <div className='paddingLeft1'>
            {(record.feePurchaseMona / 100000000) + ' MONA'}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.issueLockStatus[state.language]}
          </div>
          <div className='paddingLeft1'>
            {words[lockState][state.language]}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.dispenser[state.language]}
          </div>
          <div className='paddingLeft1'>
            {words[vendable][state.language]}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.dex[state.language]}
          </div>
          <div className='paddingLeft1'>
            {words[listed][state.language]}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.totalSupply[state.language]}
          </div>
          <div className='paddingLeft1'>
            {supply}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.amountFree[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.amountFree}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.status[state.language]}
          </div>
          <div className='paddingLeft1'>
            {words[record.status][state.language]}
          </div>
        </div>
      </div>
      {/* SP */}
      <div className="flexColumn alignItemsCenter widthMax visibleSmallOrLess">
        <div className='flexColumn boxDetailSmallScreen '>
          <div>
            {words.addressMainExhibitor[state.language]}
          </div>
          <div className='paddingLeft1 breakAll'>
            {record.addressMain}
          </div>
        </div>
        <div className='flexColumn boxDetailSmallScreen '>
          <div>
            {words.exhibitorName[state.language]}
          </div>
          <div className='paddingLeft1'>
            { state.usersGeneralIndex[record.addressMain] !== undefined ? state.usersGeneralIndex[record.addressMain].userName : null }
          </div>
        </div>
        <div className='flexColumn boxDetailSmallScreen'>
          <div>
            {words.exhibitNo[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.exhibitNo}
          </div>
        </div>
        <div className='flexColumn boxDetailSmallScreen'>
          <div>
            {words.asset[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.asset}
          </div>
        </div>
        <div className='flexColumn boxDetailSmallScreen'>
          <div>
            {words.asset_longname[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.asset_longname}
          </div>
        </div>
        <div className='flexColumn boxDetailSmallScreen'>
          <div>
            {words.addressOwner[state.language]}
          </div>
          <div className='paddingLeft1 breakAll'>
            {record.addressOwner}
          </div>
        </div>
        <div className='flexColumn boxDetailSmallScreen'>
          <div>
            {words.ownerName[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.ownerName}
          </div>
        </div>
        <div className='flexColumn boxDetailSmallScreen'>
          <div>
            {words.addressPayRoyaltyTo[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.addressPayRoyaltyTo}
          </div>
        </div>
        <div className='flexColumn boxDetailSmallScreen'>
          <div>
            {words.royaltyRecipientName[state.language]}
          </div>
          <div className='paddingLeft1'>
            { state.usersGeneralIndex[record.addressPayRoyaltyTo] !== undefined ? state.usersGeneralIndex[record.addressPayRoyaltyTo].userName : null }
          </div>
        </div>
        <div className='flexColumn boxDetailSmallScreen'>
          <div>
            {words.unitPriceMona[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.priceMona + ' MONA'}
          </div>
        </div>
        <div className='flexColumn boxDetailSmallScreen'>
          <div>
            {words.exhibitorProceedsNetMona[state.language]}
          </div>
          <div className='paddingLeft1'>
            {(record.proceedsNetMona / 100000000) + ' MONA'}
          </div>
        </div>
        <div className='flexColumn boxDetailSmallScreen'>
          <div>
            {words.royaltyMona[state.language]}
          </div>
          <div className='paddingLeft1'>
            {(record.royaltyMona / 100000000) + ' MONA'}
          </div>
        </div>
        <div className='flexColumn boxDetailSmallScreen'>
          <div>
            {words.feeExhibitMona[state.language]}
          </div>
          <div className='paddingLeft1'>
            {(record.feeExhibitMona / 100000000) + ' MONA'}
          </div>
        </div>
        <div className='flexColumn boxDetailSmallScreen'>
          <div>
            {words.feePurchaseMona[state.language]}
          </div>
          <div className='paddingLeft1'>
            {(record.feePurchaseMona / 100000000) + ' MONA'}
          </div>
        </div>
        <div className='flexColumn boxDetailSmallScreen'>
          <div>
            {words.issueLockStatus[state.language]}
          </div>
          <div className='paddingLeft1'>
            {words[lockState][state.language]}
          </div>
        </div>
        <div className='flexColumn boxDetailSmallScreen'>
          <div>
            {words.dispenser[state.language]}
          </div>
          <div className='paddingLeft1'>
            {words[vendable][state.language]}
          </div>
        </div>
        <div className='flexColumn boxDetailSmallScreen'>
          <div>
            {words.dex[state.language]}
          </div>
          <div className='paddingLeft1'>
            {words[listed][state.language]}
          </div>
        </div>
        <div className='flexColumn boxDetailSmallScreen'>
          <div>
            {words.totalSupply[state.language]}
          </div>
          <div className='paddingLeft1'>
            {supply}
          </div>
        </div>
        <div className='flexColumn boxDetailSmallScreen'>
          <div>
            {words.amountFree[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.amountFree}
          </div>
        </div>
        <div className='flexColumn boxDetailSmallScreen'>
          <div>
            {words.status[state.language]}
          </div>
          <div className='paddingLeft1'>
            {words[record.status][state.language]}
          </div>
        </div>
      </div>
    </div>
  );
}

// MONADOM INFO
function MonadomInfo(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const popupLayer = props.popupLayer;
  const card = state.popup[popupLayer].body.card;

  // 画像

  let image;
  let imageSp;

  if (card.isAMonacard === false) {
    image = <img className='cardImageLarge marginSide1' src={imageNotAMonacard} alt='not a monacard' />;
    imageSp = <img className='cardImageFullWidth' src={imageNotAMonacard} alt='not a monacard' />;
  }
  else {
    image = <img className='cardImageLarge marginSide1' src={card.cardImageUrl} alt='monacard' />;
    imageSp = <img className='cardImageFullWidth' src={card.cardImageUrlSP} alt='monacard' />;
  }

  // クリエイター情報編集

  const popup = { type: 'creatorInformation', body: card };

  const editButton =
  <button className='button1'
    onClick={ () => {
      const monacottoAddressMain = state.registeredCard[card.asset].monacottoLink?.url?.match(/mainaddress=(\w+)$/)[1];

      dispatch({ type: 'setStateMultiLayers', keys: ['creatorInformation', 'creater'], value: state.registeredCard[card.asset].creater }); 
      dispatch({ type: 'setStateMultiLayers', keys: ['creatorInformation', 'createrText'], value: state.registeredCard[card.asset].createrText }); 
      dispatch({ type: 'setStateMultiLayers', keys: ['creatorInformation', 'monacottoAddressMain'], value: monacottoAddressMain }); 
      dispatch({ type: 'setStateMultiLayers', keys: ['creatorInformation', 'createrLink', 0, 'title'], value: state.registeredCard[card.asset]?.createrLink?.[0]?.title }); 
      dispatch({ type: 'setStateMultiLayers', keys: ['creatorInformation', 'createrLink', 0, 'url'], value: state.registeredCard[card.asset]?.createrLink?.[0]?.url }); 
      dispatch({ type: 'setStateMultiLayers', keys: ['creatorInformation', 'createrLink', 1, 'title'], value: state.registeredCard[card.asset]?.createrLink?.[1]?.title }); 
      dispatch({ type: 'setStateMultiLayers', keys: ['creatorInformation', 'createrLink', 1, 'url'], value: state.registeredCard[card.asset]?.createrLink?.[1]?.url }); 
      dispatch({ type: 'setStateMultiLayers', keys: ['creatorInformation', 'createrLink', 2, 'title'], value: state.registeredCard[card.asset]?.createrLink?.[2]?.title }); 
      dispatch({ type: 'setStateMultiLayers', keys: ['creatorInformation', 'createrLink', 2, 'url'], value: state.registeredCard[card.asset]?.createrLink?.[2]?.url }); 
      dispatch({ type: 'setStateMultiLayers', keys: ['popup', props.popupLayer + 1], value: popup }); 
    }}
  >
    <img className='size2x2' src={iconEdit} alt='' />
  </button>;


  return (
    <div className=''>
      {/* PC */}
      <div className='visibleMiddleOrMore flexRow justifyContentCenter'>
        <div className=''>
          { image }
        </div>
        <div className='flexColumn alignItemsFlexStart cardImageLarge marginSide1'>
          <div className='flexColumn alignItemsFlexStart widthMax '>
            <CardSpec card={card} />
          </div>
          <div className='flexColumn alignItemsFlexStart widthMax borderKOMFatBorder padding1 marginTop0p5'>
            <div className='flexRow alignItemsFlexEnd marginBottom0p5'>
              <div className='marginRight1'>
                { words.creater[state.language] }
              </div>
              <div className='font1p5'>
                { state.registeredCard[card.asset].creater }
              </div>
            </div>
            <textarea className='widthMax height15 backgroundColorTransparent borderKOM preWrap padding0p5 marginTopBottom1'
              value={ state.registeredCard[card.asset].createrText }
            />
            <div className='flexRow justifyContentFlexStart '>
              <MonacottoLink asset={card.asset}  />
              <CreaterLink asset={card.asset} index={0} />
              <CreaterLink asset={card.asset} index={1} />
              <CreaterLink asset={card.asset} index={2} />
            </div>
            <div className='flexRow justifyContentFlexEnd widthMax '>
              { editButton }
            </div>
          </div>
        </div>
      </div>
      {/* SP */}
      <div className="visibleSmallOrLess flexColumn alignItemsCenter ">
        <div className=''>
          { imageSp }
        </div>
        <div className='flexColumn alignItemsFlexStart width96vw '>
          <div className='flexColumn alignItemsFlexStart widthMax '>
            <CardSpec card={card} />
          </div>
          <div className='flexColumn alignItemsFlexStart widthMax borderKOMFatBorder padding1 marginTop0p5'>
            <div className='flexRow alignItemsFlexEnd marginBottom0p5'>
              <div className='marginRight1'>
                { words.creater[state.language] }
              </div>
              <div className='font1p5'>
                { state.registeredCard[card.asset].creater }
              </div>
            </div>
            <textarea className='widthMax height15 backgroundColorTransparent borderKOM preWrap padding0p5 marginTopBottom1'
              value={ state.registeredCard[card.asset].createrText }
            />
            <div className='flexRow justifyContentFlexStart '>
              <MonacottoLink asset={card.asset}  />
              <CreaterLink asset={card.asset} index={0} />
              <CreaterLink asset={card.asset} index={1} />
              <CreaterLink asset={card.asset} index={2} />
            </div>
            <div className='flexRow justifyContentFlexEnd widthMax '>
              { editButton }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// CARD SPEC
function CardSpec(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const card = props.card;
  const information = state.registeredCard[card.asset];

  // エディション(レプリカ)
  let edition;

  if (information.edition === 'replica') {
    edition =
    <div className='marginSide0p5'>
      【OFFICIAL REPLICA】
    </div>;
  }

  // カードスペック

  let spec;

  if (information.category === 'magic') {

    // タイプ
    let typeText = '';

    if (information.preEffects !== undefined) {
      typeText = information.preEffects.reduce( (acc, cur) => {
        if (cur.type !== undefined && cur.type !== null && cur.type !== '') {
          return acc + words[cur.type][state.language] + ' ';
        }
        else {
          return acc;
        }
      },
      '');
    }

    if (typeText === '') {
      typeText = words.nothing[state.language];
    }

    // コスト
    let costText = '';

    if (information.costs !== undefined) {
      for (const cost of information.costs) {
        if (cost.type === 'discardCards') {
          if (cost.comparison === 'equal') {
            costText += words.discardCards01[state.language] + cost.amount + words.discardCards02[state.language];
          }
        }
      }
    }

    if (costText === '') {
      costText = words.nothing[state.language];
    }

    // 排他
    let exclusionText = '';

    if (information.exclusions !== undefined) {
      for (const exclusion of information.exclusions) {
        if (exclusion.type === 'excludeOpponent') {
          exclusionText += exclusion.typesToExclude.reduce( (acc, cur) => acc + words[cur][state.language] + ' ', '');
        }
      }
    }

    if (exclusionText === '') {
      exclusionText = words.nothing[state.language];
    }

    spec =
    <div className='flexColumn alignItemsFlexStart widthMax padding0p5' >
      <div className='flexRow justifyContentSpaceBetween alignItemsFlexStart widthMax marginTopBottom1'>
        <div className=''>
          { words.magic[state.language] }
        </div>
        <div className='flexRow alignItemsCenter'>
          { edition }
        </div>
      </div>
      <div className='flexColumn alignItemsFlexStart marginTopBottom1'>
        <div className=''>
          { words.name[state.language] }
        </div>
        <div className=''>
          { information.name }
        </div>
        <div className='preWrap marginTop1'>
          { information.flavorText }
        </div>
      </div>
      <div className='flexColumn alignItemsFlexStart marginTopBottom1'>
        <div className=''>
          { words.type[state.language] }
        </div>
        <div className='preWrap'>
          { typeText }
        </div>
      </div>
      <div className='flexColumn alignItemsFlexStart marginTopBottom1'>
        <div className=''>
          { words.effect[state.language] }
        </div>
        <div className='preWrap'>
          { information.effectText }
        </div>
      </div>
      <div className='flexColumn alignItemsFlexStart marginTopBottom1'>
        <div className=''>
          { words.cost[state.language] }
        </div>
        <div className='preWrap'>
          { costText }
        </div>
      </div>
      <div className='flexColumn alignItemsFlexStart marginTopBottom1'>
        <div className=''>
          { words.exclusion[state.language] }
        </div>
        <div className='preWrap'>
          { exclusionText }
        </div>
      </div>
      <div className='flexRow alignItemsCenter borderMonacotto marginTop1' >
        <div className='textCenter width2p4 height1p2' >
          { '0' }
        </div>
        {
          information.maginaThresholds.map( threshold =>
            <div className='textCenter width2p4 height1p2' >
              { threshold.face !== undefined ? threshold.face : threshold.upperBound }
            </div>
          )
        }
      </div>
    </div>
  }
  else { // monster
    spec =
    <div className='flexColumn alignItemsFlexStart widthMax padding0p5' >
      <div className='flexRow justifyContentSpaceBetween alignItemsFlexStart widthMax marginTopBottom1'>
        <div className=''>
          { words.knight[state.language] }
        </div>
        <div className='flexRow alignItemsCenter'>
          { edition }
        </div>
      </div>
      <div className='flexColumn alignItemsFlexStart marginTopBottom1'>
        <div className=''>
          { words.name[state.language] }
        </div>
        <div className=''>
          { information.name }
        </div>
      </div>
      <div className='flexColumn alignItemsFlexStart marginTopBottom1'>
        <div className=''>
          { words.profile[state.language] }
        </div>
        <div className=''>
          { information.feature }
        </div>
      </div>
    </div>
  }

  return spec;
}

// MONACOTTO LINK
function MonacottoLink(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const asset = props.asset;

  if (state.registeredCard[asset].monacottoLink?.url === undefined) {
    return null;
  }

  return (
    <div className='flexRow alignItemsCenter marginBottom0p5 marginSide0p5'>
      <button className='buttonMainColor widthMin10 height2p2 paddingSide1 flexRow justifyContentCenter alignItemsCenter ' tabindex='0' 
        onClick={ () => {
          window.open( state.registeredCard[asset].monacottoLink.url );
        }}
      >
        <img className='heightMax' src={logoMonacotto} alt='monacotto' />
        <img className='heightMax' src={iconCotto} alt='cotto' />
      </button>
      <button className='button1' tabindex='0' 
        onClick={ () => {
          navigator.clipboard.writeText( state.registeredCard[asset].monacottoLink.url )
          .then()
          .catch();
        }}
      >
        <img className='size2x2' src={iconCopy} alt='copy' />
      </button>
    </div>
  );
}

// CREATER LINK
function CreaterLink(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const asset = props.asset;
  const index = props.index;

  if (state.registeredCard[asset].createrLink?.[index] === undefined) {
    return null;
  }

  return (
    <div className='flexRow alignItemsCenter marginBottom0p5 marginSide0p5'>
      <button className='buttonMainColor widthMin10 height2p2 paddingSide1 textCenter flexRow justifyContentCenter alignItemsCenter ' tabindex='0' 
        onClick={ () => {
          window.open( state.registeredCard[asset].createrLink[index].url );
        }}
      >
        { state.registeredCard[asset].createrLink[index].title }
      </button>
      <button className='button1' tabindex='0' 
        onClick={ () => {
          navigator.clipboard.writeText( state.registeredCard[asset].createrLink[index].url )
          .then()
          .catch();
        }}
      >
        <img className='size2x2' src={iconCopy} alt='' />
      </button>
    </div>
  );
}

// CREATOR INFORMATION
function CreatorInformation(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const item = state.popup[props.popupLayer].body;
  const language = state.language;
  const pass = state.config.clientParameters.specialMessage;
  const network = state.networkMona;

  // iPhone アプリでキーカードを読み、オーナーアドレスの鍵で署名して登録する
  const nfcrwScan = useNfcrwScan({
    enabled: state.walletType === 'nfcNative',
    language,
    onRecords: async ({ records }) => {
      let secrets;

      try {
        secrets = await getSecretsFromKeyCardRecords({ dispatch, pass, records, language, network });
      }
      catch {
        return;
      }

      handleClickEditCreatorInformation(state, dispatch, item.asset, { keyPairs: secrets.keyPairs });
    },
    onFailure: () => {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToReadNfc[language] });
    },
  });

  // 登録ボタン

  let registerButton;

  if (state.walletType === 'mpurse') {
    registerButton =
    <div className='flexRow justifyContentCenter widthMax marginTop1'>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
        onClick={ () => {
          handleClickEditCreatorInformation(state, dispatch, item.asset);
        }}
      >
        <div>
          {words.signByOwnerAddressToRegister[state.language]}
        </div>
        <img className='size2x2' src={iconSign} alt='sign' />
      </button>
    </div>
  }
  else if (state.walletType === 'nfc') {
    registerButton =
    <div className='flexRow justifyContentCenter widthMax marginTop1'>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
        onClick={ () => {
          const callback = (keyPairs) => handleClickEditCreatorInformation(state, dispatch, item.asset, { keyPairs });
          handleClickNfc(state, dispatch, callback);
        }}
      >
        <div>
          {words.signByOwnerAddressToRegister[state.language]}
        </div>
        <div>
          <img className='size2x2' src={iconKeyCard} alt='nfc' />
        </div>
      </button>
    </div>
  }
  else if (state.walletType === 'nfcNative') {
    registerButton =
    <div className='flexRow justifyContentCenter widthMax marginTop1'>
      <NativeAppReadButton
        nfcrwScan={nfcrwScan}
        intent='keycard'
        marginTop={false}
        face={
          <>
            <div>
              {words.signByOwnerAddressToRegister[state.language]}
            </div>
            <div>
              <img className='size2x2' src={iconKeyCard} alt='nfc' />
            </div>
          </>
        }
      />
    </div>
  }
  else { // qr
    registerButton =
    <div className='flexRow justifyContentCenter widthMax marginTop1'>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
        onClick={ () => {
          const callback = (keyPairs) => handleClickEditCreatorInformation(state, dispatch, item.asset, { keyPairs });
          handleClickScanQr(state, dispatch, callback, { popupLayer: props.popupLayer + 1 });
        }}
      >
        <div>
          {words.signByOwnerAddressToRegister[state.language]}
        </div>
        <div>
          <img className='size2x2' src={iconQr} alt='qr' />
        </div>
      </button>
    </div>
  }


  return (
    <div>
      {/* PC */}
      <div className="visibleMiddleOrMore flexColumn alignItemsCenter">
        <div className='flexColumn alignItemsFlexStart borderKOM marginSide1 marginTop1 padding0p5'>
          {/* asset */}
          <div className='margin1'>
            { item.asset }
          </div>
          {/* creater */}
          <TextArea2 fieldName='creatorInformationCreater' keys={['creatorInformation', 'creater']} face={words.creater[state.language]}
            boxClass='box4 height4 margin1 ' textAreaClass='textArea1 height70PC'
          />
          {/* createrText */}
          <TextArea2 fieldName='creatorInformationCreaterText' keys={['creatorInformation', 'createrText']} face={words.createrText[state.language]}
            boxClass='box4 margin1' textAreaClass='textArea1'
          />
          {/* monacottoAddressMain */}
          <TextArea2 fieldName='creatorInformationMonacottoAddressMain' keys={['creatorInformation', 'monacottoAddressMain']}
            face={words.monacottoAddressMain[state.language]} boxClass='box4 height4 margin1 ' textAreaClass='textArea1 height70PC'
          />
          {/* createrLink */}
          <TextArea2 fieldName='creatorInformationCreaterLink0Title' keys={['creatorInformation', 'createrLink', 0, 'title']} face={words.createrLinkTitle[state.language] + 1}
            boxClass='box4 height4 margin1 ' textAreaClass='textArea1 height70PC'
          />
          <TextArea2 fieldName='creatorInformationCreaterLink0Url' keys={['creatorInformation', 'createrLink', 0, 'url']} face={words.createrLinkUrl[state.language] + 1}
            boxClass='box4 height4 margin1 ' textAreaClass='textArea1 height70PC'
          />
          <TextArea2 fieldName='creatorInformationCreaterLink1Title' keys={['creatorInformation', 'createrLink', 1, 'title']} face={words.createrLinkTitle[state.language] + 2}
            boxClass='box4 height4 margin1 ' textAreaClass='textArea1 height70PC'
          />
          <TextArea2 fieldName='creatorInformationCreaterLink1Url' keys={['creatorInformation', 'createrLink', 1, 'url']} face={words.createrLinkUrl[state.language] + 2}
            boxClass='box4 height4 margin1 ' textAreaClass='textArea1 height70PC'
          />
          <TextArea2 fieldName='creatorInformationCreaterLink2Title' keys={['creatorInformation', 'createrLink', 2, 'title']} face={words.createrLinkTitle[state.language] + 3}
            boxClass='box4 height4 margin1 ' textAreaClass='textArea1 height70PC'
          />
          <TextArea2 fieldName='creatorInformationCreaterLink2Url' keys={['creatorInformation', 'createrLink', 2, 'url']} face={words.createrLinkUrl[state.language] + 3}
            boxClass='box4 height4 margin1 ' textAreaClass='textArea1 height70PC'
          />
          {/* register button */}
          { registerButton }
        </div>
      </div>
      {/* SP */}
      <div className="visibleSmallOrLess flexColumn alignItemsFlexStart widthMax padding1">
        {/* asset */}
        <div className=''>
          { item.asset }
        </div>
        {/* creater */}
        <TextArea2 fieldName='creatorInformationCreater' keys={['creatorInformation', 'creater']} face={words.creater[state.language]}
          outerClass='widthMax' boxClass='box4 width96PC height4 marginTop1 ' textAreaClass='textArea1 height70PC'
        />
        {/* createrText */}
        <TextArea2 fieldName='creatorInformationCreaterText' keys={['creatorInformation', 'createrText']} face={words.createrText[state.language]}
          outerClass='widthMax' boxClass='box4 width96PC marginTop1 ' textAreaClass='textArea1 '
        />
        {/* monacottoAddressMain */}
        <TextArea2 fieldName='creatorInformationMonacottoAddressMain' keys={['creatorInformation', 'monacottoAddressMain']}
          face={words.monacottoAddressMain[state.language]} outerClass='widthMax' boxClass='box4 width96PC height4 marginTop1 ' textAreaClass='textArea1 height70PC'
        />
        {/* createrLink */}
        <TextArea2 fieldName='creatorInformationCreaterLink0Title' keys={['creatorInformation', 'createrLink', 0, 'title']} face={words.createrLinkTitle[state.language] + 1}
          outerClass='widthMax' boxClass='box4 width96PC height4 marginTop1 ' textAreaClass='textArea1 height70PC'
        />
        <TextArea2 fieldName='creatorInformationCreaterLink0Url' keys={['creatorInformation', 'createrLink', 0, 'url']} face={words.createrLinkUrl[state.language] + 1}
          outerClass='widthMax' boxClass='box4 width96PC height4 marginTop1 ' textAreaClass='textArea1 height70PC'
        />
        <TextArea2 fieldName='creatorInformationCreaterLink1Title' keys={['creatorInformation', 'createrLink', 1, 'title']} face={words.createrLinkTitle[state.language] + 2}
          outerClass='widthMax' boxClass='box4 width96PC height4 marginTop1 ' textAreaClass='textArea1 height70PC'
        />
        <TextArea2 fieldName='creatorInformationCreaterLink1Url' keys={['creatorInformation', 'createrLink', 1, 'url']} face={words.createrLinkUrl[state.language] + 2}
          outerClass='widthMax' boxClass='box4 width96PC height4 marginTop1 ' textAreaClass='textArea1 height70PC'
        />
        <TextArea2 fieldName='creatorInformationCreaterLink2Title' keys={['creatorInformation', 'createrLink', 2, 'title']} face={words.createrLinkTitle[state.language] + 3}
          outerClass='widthMax' boxClass='box4 width96PC height4 marginTop1 ' textAreaClass='textArea1 height70PC'
        />
        <TextArea2 fieldName='creatorInformationCreaterLink2Url' keys={['creatorInformation', 'createrLink', 2, 'url']} face={words.createrLinkUrl[state.language] + 3}
          outerClass='widthMax' boxClass='box4 width96PC height4 marginTop1 ' textAreaClass='textArea1 height70PC'
        />
        {/* register button */}
        { registerButton }
      </div>
    </div>
  );
}

export {
  ItemDetail,
  ItemDetailMore,
  MonadomInfo,
  CreatorInformation,
};
